// Spanish translations — source of truth
const es = {
  navigation: {
    home: 'Inicio',
    services: 'Servicios',
    'success-stories': 'Casos de Exito',
    products: 'Productos',
    contact: 'Contacto',
  },

  hero: {
    title: 'Donde la ingenieria global se encuentra con la confianza local',
    subtitle:
      'Desarrollamos soluciones tecnologicas a medida para potenciar tu negocio con innovacion y calidad.',
    cta: 'Hablemos de tu proyecto',
  },

  services: {
    sectionTitle: 'Nuestros Servicios',
    sectionSubtitle:
      'Soluciones integrales para impulsar la transformacion digital de tu empresa.',
    items: {
      automatizaciones: {
        title: 'Automatizaciones',
        description:
          'Workflows automatizados, formularios inteligentes y sistemas personalizados para optimizar procesos clave.',
      },
      'mobile-apps': {
        title: 'Aplicaciones Mobile',
        description:
          'Apps nativas para iOS y Android, PWAs y prototipos funcionales con integracion a tus sistemas.',
      },
      integraciones: {
        title: 'Integraciones',
        description:
          'APIs REST & GraphQL, conectores ERP/CRM/CMS y sincronizacion de datos en tiempo real.',
      },
      outsourcing: {
        title: 'Resource Outsourcing',
        description:
          'Equipos y perfiles especializados de forma flexible: frontend, backend, QA, DevOps y mas.',
      },
      'desarrollo-web': {
        title: 'Desarrollo Web',
        description:
          'Sitios web modernos, plataformas a medida y micrositios interactivos con las ultimas tecnologias.',
      },
      'bases-de-datos': {
        title: 'Bases de Datos',
        description:
          'Diseno, migracion y optimizacion de bases de datos relacionales y NoSQL para alto rendimiento.',
      },
      cloud: {
        title: 'Cloud & DevOps',
        description:
          'Infraestructura en la nube, CI/CD, contenedores y despliegues automatizados en AWS, Azure y GCP.',
      },
      seguridad: {
        title: 'Seguridad',
        description:
          'Auditorias de seguridad, implementacion de mejores practicas y proteccion de datos sensibles.',
      },
      analitica: {
        title: 'Analitica & BI',
        description:
          'Dashboards interactivos, reportes automatizados y visualizacion de datos para decisiones inteligentes.',
      },
    },
  },

  stats: {
    motto:
      'Software Factory que crea soluciones tecnologicas innovadoras. Nuestro equipo esta formado por expertos apasionados.',
    items: {
      years: 'Anos de Experiencia',
      clients: 'Clientes Satisfechos',
      projects: 'Proyectos Entregados',
      experts: 'Expertos en el Equipo',
    },
  },

  successStories: {
    sectionTitle: 'Casos de Exito',
    sectionSubtitle:
      'Descubri como ayudamos a nuestros clientes a alcanzar sus objetivos.',
    readMore: 'Leer mas',
    prevButton: 'Anterior',
    nextButton: 'Siguiente',
    items: {
      'story-1': {
        title: 'Transformacion Digital Retail',
        description:
          'Migracion completa de plataforma e-commerce con integracion de inventario en tiempo real.',
        category: 'E-commerce',
        imageAlt: 'Plataforma e-commerce con integracion de inventario',
      },
      'story-2': {
        title: 'App de Gestion Logistica',
        description:
          'Aplicacion mobile para seguimiento de envios y optimizacion de rutas de entrega.',
        category: 'Logistica',
        imageAlt: 'App mobile de seguimiento logistico',
      },
      'story-3': {
        title: 'Sistema de Reservas Online',
        description:
          'Plataforma de reservas con disponibilidad en tiempo real y pagos integrados.',
        category: 'Hoteleria',
        imageAlt: 'Sistema de reservas online para hoteleria',
      },
      'story-4': {
        title: 'Dashboard de Analytics',
        description:
          'Panel de control con metricas en tiempo real y reportes automatizados para toma de decisiones.',
        category: 'Business Intelligence',
        imageAlt: 'Dashboard de analytics con metricas en tiempo real',
      },
      'story-5': {
        title: 'Automatizacion de Procesos',
        description:
          'Workflows automatizados que redujeron tiempos operativos en un 60% para una empresa financiera.',
        category: 'Fintech',
        imageAlt: 'Automatizacion de procesos para empresa financiera',
      },
      'story-6': {
        title: 'Plataforma Educativa',
        description:
          'Sistema LMS con videoconferencia integrada, evaluaciones y seguimiento de progreso estudiantil.',
        category: 'Educacion',
        imageAlt: 'Plataforma educativa con videoconferencia integrada',
      },
    },
  },

  partners: {
    sectionTitle: 'Tecnologías que utilizamos',
    sectionSubtitle:
      'Trabajamos con tecnologías y plataformas líderes del mercado para desarrollar soluciones a medida, escalables y confiables.',
  },

  products: {
    overview: {
      eyebrow: 'Productos DSW',
      title: 'Software pensado para tu industria',
      subtitle:
        'Productos desarrollados por nosotros, listos para usar y respaldados por nuestro equipo de ingeniería.',
      ctaTrial: 'Probar gratis 30 días',
      ctaLearnMore: 'Conocer más',
      benefitsTitle: '¿Por qué elegir productos DSW?',
      benefitsSubtitle:
        'No solo desarrollamos software a medida. Construimos productos pensados para resolver problemas reales.',
      benefits: {
        support: {
          title: 'Soporte directo',
          description:
            'Trabajás con el mismo equipo que construye el producto. Sin intermediarios, sin tickets perdidos.',
        },
        scalable: {
          title: 'Escalable',
          description:
            'Pensados para crecer con tu negocio. Desde un consultorio o tienda hasta múltiples sucursales.',
        },
        secure: {
          title: 'Seguro y confiable',
          description:
            'Datos encriptados, backups automáticos y cumplimiento de normativas locales de privacidad.',
        },
        custom: {
          title: 'Adaptable',
          description:
            'Si necesitás algo específico para tu negocio, lo desarrollamos. Tenés acceso al equipo que lo construye.',
        },
      },
    },
    medicare: {
      meta: {
        title: 'Medicare — Gestión integral para consultorios y clínicas',
      },
      hero: {
        eyebrow: 'Healthcare',
        title: 'Medicare',
        tagline:
          'La plataforma todo-en-uno para consultorios médicos, clínicas y centros de salud.',
        description:
          'Gestioná turnos, historias clínicas, recetas digitales y pacientes desde un solo lugar. Diseñado por profesionales de la salud, construido con tecnología moderna.',
        ctaTrial: 'Probar gratis 30 días',
        ctaContact: 'Hablar con ventas',
      },
      teaser: {
        category: 'Healthcare',
        title: 'Medicare',
        subtitle: 'Gestión integral para consultorios y clínicas',
        description:
          'Turnos online, historia clínica digital y recetas electrónicas en una sola plataforma.',
      },
      features: {
        appointments: {
          title: 'Turnos online',
          description:
            'Tus pacientes reservan turnos 24/7 desde su celular. Recordatorios automáticos por email y WhatsApp.',
        },
        records: {
          title: 'Historia clínica digital',
          description:
            'Toda la información médica del paciente accesible al instante, segura y centralizada.',
        },
        prescriptions: {
          title: 'Recetas digitales',
          description:
            'Generá recetas electrónicas firmadas digitalmente, listas para enviar al paciente o farmacia.',
        },
        monitoring: {
          title: 'Seguimiento de pacientes',
          description:
            'Monitoreá tratamientos, evolución y próximos controles. Alertas automáticas para no perder ningún seguimiento.',
        },
        multiUser: {
          title: 'Multi-profesional',
          description:
            'Cada médico tiene su propia agenda y historial. Coordinación entre especialidades sin fricción.',
        },
        security: {
          title: 'Seguridad y privacidad',
          description:
            'Encriptación end-to-end, backups automáticos y cumplimiento de normativas de datos médicos.',
        },
      },
      audience: {
        title: '¿Para quién es Medicare?',
        items: [
          'Consultorios médicos privados',
          'Clínicas de pequeño y mediano porte',
          'Centros de diagnóstico',
          'Profesionales independientes (kinesiólogos, psicólogos, nutricionistas)',
          'Centros odontológicos',
        ],
      },
      finalCta: {
        title: 'Empezá hoy con Medicare',
        subtitle: 'Probalo gratis durante 30 días, sin tarjeta de crédito.',
        ctaTrial: 'Probar gratis 30 días',
      },
    },
    tienda360: {
      meta: {
        title: 'Tienda360 — Gestión de stock y ventas para comercios',
      },
      hero: {
        eyebrow: 'Retail',
        title: 'Tienda360',
        tagline:
          'Stock, ventas y reportes en una sola plataforma. Para comercios que quieren crecer sin perder el control.',
        description:
          'Olvidate de las planillas. Tienda360 te da visibilidad total de tu negocio: qué se vende, qué falta, qué deja más margen.',
        ctaTrial: 'Probar gratis 30 días',
        ctaContact: 'Hablar con ventas',
      },
      teaser: {
        category: 'Retail',
        title: 'Tienda360',
        subtitle: 'Gestión de stock y ventas para comercios',
        description:
          'Inventario en tiempo real, punto de venta y reportes de negocio en una plataforma intuitiva.',
      },
      features: {
        inventory: {
          title: 'Inventario en tiempo real',
          description:
            'Sabé al instante qué tenés, qué falta y qué se mueve más. Alertas automáticas por bajo stock.',
        },
        pos: {
          title: 'Punto de venta',
          description:
            'Cobrá rápido con un POS pensado para comercios reales. Funciona en tablet, computadora o mobile.',
        },
        reports: {
          title: 'Reportes de negocio',
          description:
            'Productos más vendidos, márgenes por categoría, performance por sucursal. Decisiones con datos, no con intuición.',
        },
        billing: {
          title: 'Facturación electrónica',
          description:
            'Emití facturas electrónicas legales en segundos. Integración con AFIP/SAT lista para usar.',
        },
        multiBranch: {
          title: 'Multi-sucursal',
          description:
            'Gestioná todas tus sucursales desde un solo panel. Stock centralizado, reportes consolidados.',
        },
        payments: {
          title: 'Múltiples medios de pago',
          description:
            'Efectivo, tarjeta, QR, transferencia. Todo conciliado automáticamente en tu cierre de caja.',
        },
      },
      audience: {
        title: '¿Para quién es Tienda360?',
        items: [
          'Comercios minoristas (indumentaria, librería, ferretería, etc.)',
          'Cadenas de tiendas con múltiples sucursales',
          'Almacenes y autoservicios de barrio',
          'Tiendas de productos especializados',
          'Emprendimientos en crecimiento',
        ],
      },
      finalCta: {
        title: 'Empezá hoy con Tienda360',
        subtitle: 'Probalo gratis durante 30 días, sin tarjeta de crédito.',
        ctaTrial: 'Probar gratis 30 días',
      },
    },
  },

  contact: {
    title: 'Contactanos',
    description:
      'Estamos aqui para ayudarte. Completa el formulario y nos pondremos en contacto contigo lo antes posible.',
    labels: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Email',
      message: 'Mensaje',
    },
    submitButton: 'Enviar Mensaje',
    submitting: 'Enviando...',
    validation: {
      required: 'Este campo es requerido',
      invalidEmail: 'Email inválido',
    },
    feedback: {
      success: '¡Mensaje enviado! Te responderemos a la brevedad.',
      errorGeneric: 'Error al enviar el mensaje. Intentá de nuevo más tarde.',
      errorInvalid: 'Datos inválidos. Revisá los campos.',
      errorConnection: 'Error de conexión. Revisá tu internet e intentá de nuevo.',
    },
  },

  footer: {
    tagline: 'Soluciones tecnologicas innovadoras para impulsar tu negocio.',
    copyright: '© 2024 DSW Solutions. Todos los derechos reservados.',
    sections: {
      empresa: {
        title: 'Empresa',
        links: {
          inicio: 'Inicio',
          servicios: 'Servicios',
          casosDeExito: 'Casos de Exito',
          productos: 'Productos',
        },
      },
      productos: {
        title: 'Productos',
        links: {
          medicare: 'Medicare',
          tienda360: 'Tienda360',
          allProducts: 'Ver todos',
        },
      },
      legal: {
        title: 'Legal',
        links: {
          privacidad: 'Politica de Privacidad',
          avisoLegal: 'Aviso Legal',
          sitemap: 'Sitemap',
        },
      },
    },
  },
};

export default es;
